import { ImgID } from "../../image_loader/img_id.js";
import type { DailyTaskRewardType } from "../../api/dto/daily_tasks.dto.js";

export function dailyTaskRewardIcon( type: DailyTaskRewardType ): ImgID
{
  switch ( type )
  {
    case "coin": return ImgID.UI_DailyTasksTaskCoins;
    case "heart": return ImgID.IconHeart;
    case "infinite_hearts": return ImgID.UI_ShopInfiniteHeart;
    case "infinite_balls": return ImgID.UI_GameStartInfiniteBallsBooster;
    case "multiballs": return ImgID.UI_GameStartMultiballsBooster;
    case "big_balls": return ImgID.UI_GameStartBigBallBooster;
    case "fireworks": return ImgID.UI_GameStartFireworkBooster;
    case "mines": return ImgID.UI_PassiveBoosterMine;
    case "freezes": return ImgID.UI_GameFreezeBooster;
  }
}
